import { a as _toConsumableArray, b as _objectWithoutProperties, c as _slicedToArray, _ as _objectSpread2, f as _asyncToGenerator } from './_rollupPluginBabelHelpers-fb970440.js';
import React, { useContext, useEffect, useState } from 'react';
import { useQuantaFormikContext, useResponsiveParams, Text, QuantaForm, InputGrid, QuantaFormik, Paper, DataGridGroup, MixedGridGroup } from 'quanta-ui';
import { h as GET_BUY_HEALTH_POLICY_VAR_DETAILS, d as INTERMEDIARY_CD_ACCOUNTS, P as PAY_PREMIUM_LIST, G as GET_CUSTOMER_TYPE_DOMAIN, C as CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL, a as GET_DATE_TIME, O as OnlinePayment, b as Cheque, D as DemandDraft, K as KASH_PASH_SLIP, I as ISSUE_POLICY } from './demand-draft-4fa845ea.js';
import 'react-helmet';
import { useParams } from 'react-router-dom';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useQuery } from '@apollo/client';
import './queries-3df8abcc.js';
import { E as Error } from './error-ee5266a9.js';
import { L as Loading } from './loading-c16d3bd3.js';
import './queries-a3e6305b.js';
import { useParams as useParams$1 } from 'react-router';
import { a as ConfigContext } from './ConfigProvider-9522944e.js';
import { P as Parse } from './CurrencyFormater-d288bc4f.js';
import { D as Digilink } from './digilink-57b9be2d.js';
import { u as useMutationQuery } from './useMutationQuery-42b53d8d.js';
import './proposal/health/state.js';
import 'moment';
import './queries-9ae26450.js';
import disableScroll from 'disable-scroll';
import './queries-5e809970.js';
import './queries-86f06197.js';
import '@fortawesome/free-brands-svg-icons';
import './queries-d745c605.js';
import TermsAndConditions from './terms-and-conditions-e1c49b6d.js';

function CdWalletHealth(_ref) {
  var _dataReactiveVar$, _dataReactiveVar$$int, _dataReactiveVar$2, _PT$toString, _values$cdWallet2, _values$cdWallet3, _dataBuyPolicy$buyHea, _values$cdWallet4, _values$cdWallet6;

  var REACTIVE_VAR_QUERY = _ref.REACTIVE_VAR_QUERY,
      planName = _ref.planName,
      reactiveVarName = _ref.reactiveVarName,
      PT = _ref.PT,
      productCode = _ref.productCode;

  var _useContext = useContext(ConfigContext),
      branding = _useContext.branding;

  var _useQuantaFormikConte = useQuantaFormikContext(),
      values = _useQuantaFormikConte.values,
      errors = _useQuantaFormikConte.errors,
      setFieldValue = _useQuantaFormikConte.setFieldValue;

  var params = useParams();
  var plan_name = params !== null && params !== void 0 && params.plan_name ? params === null || params === void 0 ? void 0 : params.plan_name : planName;

  var _useQuery = useQuery(REACTIVE_VAR_QUERY, {
    fetchPolicy: 'cache-first'
  }),
      loadingReactiveVar = _useQuery.loading,
      errorReactiveVar = _useQuery.error,
      dataReactiveVar = _useQuery.data;

  var _useQuery2 = useQuery(GET_BUY_HEALTH_POLICY_VAR_DETAILS, {
    fetchPolicy: 'cache-first'
  });
      _useQuery2.loading;
      _useQuery2.error;
      var dataBuyPolicy = _useQuery2.data;

  if (dataBuyPolicy) {
    //console.log("CD Wallet  Payment dataBuyPolicy", dataBuyPolicy);
    var prembuyHealthPolicy = dataBuyPolicy === null || dataBuyPolicy === void 0 ? void 0 : dataBuyPolicy.buyHealthPolicy;
    prembuyHealthPolicy === null || prembuyHealthPolicy === void 0 ? void 0 : prembuyHealthPolicy.quoteData;
    var premplanData = prembuyHealthPolicy === null || prembuyHealthPolicy === void 0 ? void 0 : prembuyHealthPolicy.planData;
    premplanData === null || premplanData === void 0 ? void 0 : premplanData.plans;
  } // console.log("PT",PT === 'Intermediary');
  // console.log("reactive var",dataReactiveVar[`${reactiveVarName}`].intermediaryDetails?.code );


  var _useQuery3 = useQuery(INTERMEDIARY_CD_ACCOUNTS, {
    variables: {
      input: {
        intermediaryCode: (_dataReactiveVar$ = dataReactiveVar["".concat(reactiveVarName)]) === null || _dataReactiveVar$ === void 0 ? void 0 : (_dataReactiveVar$$int = _dataReactiveVar$.intermediaryDetails) === null || _dataReactiveVar$$int === void 0 ? void 0 : _dataReactiveVar$$int.code,
        customerID: PT === 'Customer' ? (_dataReactiveVar$2 = dataReactiveVar["".concat(reactiveVarName)]) === null || _dataReactiveVar$2 === void 0 ? void 0 : _dataReactiveVar$2.proposerDetails.id : '',
        productCode: productCode ? productCode : '',
        payerType: (PT === null || PT === void 0 ? void 0 : (_PT$toString = PT.toString()) === null || _PT$toString === void 0 ? void 0 : _PT$toString.toLowerCase()) === 'customer' ? '1' : '2',
        //2 -Intermediary ; 1 - Customer
        searchType: 'PP' // PP for payment page

      }
    },
    fetchPolicy: 'cache-first',
    onCompleted: function onCompleted(data) {
      if ((data === null || data === void 0 ? void 0 : data.intermediaryCDAccounts.length) > 0) {
        var _data$intermediaryCDA;

        setFieldValue("cdWallet.cdAccountNo", data === null || data === void 0 ? void 0 : (_data$intermediaryCDA = data.intermediaryCDAccounts[0]) === null || _data$intermediaryCDA === void 0 ? void 0 : _data$intermediaryCDA.AccountID);
      }
    }
  }),
      loading = _useQuery3.loading,
      error = _useQuery3.error,
      data = _useQuery3.data;

  var repeat = useResponsiveParams({
    for_mobile: 1,
    for_desktop: 3
  });
  useEffect(function () {
    var _values$cdWallet;

    if (!(values !== null && values !== void 0 && (_values$cdWallet = values.cdWallet) !== null && _values$cdWallet !== void 0 && _values$cdWallet.cdAccountNo) && data) {
      var _data$intermediaryCDA2, _data$intermediaryCDA3, _data$intermediaryCDA4;

      setFieldValue("cdWallet.cdAccountNo", data === null || data === void 0 ? void 0 : (_data$intermediaryCDA2 = data.intermediaryCDAccounts[0]) === null || _data$intermediaryCDA2 === void 0 ? void 0 : _data$intermediaryCDA2.AccountID);
      setFieldValue("cdWallet.cdAccountBalance", data === null || data === void 0 ? void 0 : (_data$intermediaryCDA3 = data.intermediaryCDAccounts[0]) === null || _data$intermediaryCDA3 === void 0 ? void 0 : _data$intermediaryCDA3.AccountBalance);
      setFieldValue("cdWallet.cdAccountCount", data === null || data === void 0 ? void 0 : (_data$intermediaryCDA4 = data.intermediaryCDAccounts) === null || _data$intermediaryCDA4 === void 0 ? void 0 : _data$intermediaryCDA4.length);
    }
  }, [values, data]);

  if (loading || loadingReactiveVar) {
    return /*#__PURE__*/React.createElement("div", {
      className: "min-h-screen"
    }, /*#__PURE__*/React.createElement(Loading, null));
  }

  if (error || errorReactiveVar) {
    return /*#__PURE__*/React.createElement(Error, {
      error: error || errorReactiveVar
    });
  }

  var intermediaryCDAccounts = data.intermediaryCDAccounts;
  var reactiveVarData = dataReactiveVar["".concat(reactiveVarName)];
  var grid_data = values !== null && values !== void 0 && (_values$cdWallet2 = values.cdWallet) !== null && _values$cdWallet2 !== void 0 && _values$cdWallet2.cdAccountBalance ? // &&
  // values?.cdWallet?.cdAccountNo
  [(values === null || values === void 0 ? void 0 : (_values$cdWallet3 = values.cdWallet) === null || _values$cdWallet3 === void 0 ? void 0 : _values$cdWallet3.cdAccountCount) > 0 && (intermediaryCDAccounts === null || intermediaryCDAccounts === void 0 ? void 0 : intermediaryCDAccounts.length) > 0 ? {
    type: 'select',
    label: 'Choose CD Account',
    onDataChange: function onDataChange(val, setFieldValue) {
      var _intermediaryCDAccoun;

      setFieldValue("cdWallet.cdAccountBalance", intermediaryCDAccounts === null || intermediaryCDAccounts === void 0 ? void 0 : (_intermediaryCDAccoun = intermediaryCDAccounts.find(function (cdAccountNo) {
        return (cdAccountNo === null || cdAccountNo === void 0 ? void 0 : cdAccountNo.AccountID) === val;
      })) === null || _intermediaryCDAccoun === void 0 ? void 0 : _intermediaryCDAccoun.AccountBalance);
    },
    data: intermediaryCDAccounts ? _toConsumableArray(intermediaryCDAccounts === null || intermediaryCDAccounts === void 0 ? void 0 : intermediaryCDAccounts.map(function (cdAccountNo) {
      return {
        label: cdAccountNo !== null && cdAccountNo !== void 0 && cdAccountNo.AccountID ? cdAccountNo === null || cdAccountNo === void 0 ? void 0 : cdAccountNo.AccountID : '',
        value: cdAccountNo !== null && cdAccountNo !== void 0 && cdAccountNo.AccountID ? cdAccountNo === null || cdAccountNo === void 0 ? void 0 : cdAccountNo.AccountID : ''
      };
    })) : [],
    name: 'cdWallet.cdAccountNo',
    disabled: (dataBuyPolicy === null || dataBuyPolicy === void 0 ? void 0 : (_dataBuyPolicy$buyHea = dataBuyPolicy.buyHealthPolicy) === null || _dataBuyPolicy$buyHea === void 0 ? void 0 : _dataBuyPolicy$buyHea.isProposalApplicableForPayment) === false
  } : null, (values === null || values === void 0 ? void 0 : (_values$cdWallet4 = values.cdWallet) === null || _values$cdWallet4 === void 0 ? void 0 : _values$cdWallet4.cdAccountCount) > 0 && (intermediaryCDAccounts === null || intermediaryCDAccounts === void 0 ? void 0 : intermediaryCDAccounts.length) > 0 ? {
    type: 'render',
    name: 'cdWallet.cdAccountBalance',
    component: function component() {
      var _values$cdWallet5, _errors$cdWallet;

      return /*#__PURE__*/React.createElement("div", {
        className: "flex flex-col mt-2"
      }, /*#__PURE__*/React.createElement(Text, {
        type: "label"
      }, "CD Account Balance"), /*#__PURE__*/React.createElement("span", null, Parse(values === null || values === void 0 ? void 0 : (_values$cdWallet5 = values.cdWallet) === null || _values$cdWallet5 === void 0 ? void 0 : _values$cdWallet5.cdAccountBalance, true, false, branding, true)), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Text, {
        severity: "error",
        type: "label"
      }, errors === null || errors === void 0 ? void 0 : (_errors$cdWallet = errors.cdWallet) === null || _errors$cdWallet === void 0 ? void 0 : _errors$cdWallet.cdAccountBalance)));
    }
  } : {
    type: 'render',
    colSpan: repeat,
    component: function component() {
      return /*#__PURE__*/React.createElement(Text, {
        severity: "neutral-darker",
        className: "flex justify-center text-2xl"
      }, "No CD Accounts Found");
    }
  }, (values === null || values === void 0 ? void 0 : (_values$cdWallet6 = values.cdWallet) === null || _values$cdWallet6 === void 0 ? void 0 : _values$cdWallet6.cdAccountCount) > 0 && (intermediaryCDAccounts === null || intermediaryCDAccounts === void 0 ? void 0 : intermediaryCDAccounts.length) > 0 ? {
    type: 'render',
    name: 'cdWallet.cdAccountBalance',
    component: function component() {
      var _reactiveVarData$plan, _reactiveVarData$plan2, _reactiveVarData$plan3, _reactiveVarData$plan4, _reactiveVarData$plan5, _reactiveVarData$plan6, _reactiveVarData$plan7;

      return /*#__PURE__*/React.createElement("div", {
        className: "flex flex-col mt-2"
      }, /*#__PURE__*/React.createElement(Text, {
        type: "label"
      }, "Payment Amount"), /*#__PURE__*/React.createElement("span", null, Parse((reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$plan = reactiveVarData.planData) === null || _reactiveVarData$plan === void 0 ? void 0 : (_reactiveVarData$plan2 = _reactiveVarData$plan.plans) === null || _reactiveVarData$plan2 === void 0 ? void 0 : (_reactiveVarData$plan3 = _reactiveVarData$plan2.find(function (p) {
        return (p === null || p === void 0 ? void 0 : p.name) === plan_name;
      })) === null || _reactiveVarData$plan3 === void 0 ? void 0 : (_reactiveVarData$plan4 = _reactiveVarData$plan3.premium) === null || _reactiveVarData$plan4 === void 0 ? void 0 : _reactiveVarData$plan4.totalPremium) || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$plan5 = reactiveVarData.planData) === null || _reactiveVarData$plan5 === void 0 ? void 0 : (_reactiveVarData$plan6 = _reactiveVarData$plan5.plans) === null || _reactiveVarData$plan6 === void 0 ? void 0 : (_reactiveVarData$plan7 = _reactiveVarData$plan6.find(function (p) {
        return (p === null || p === void 0 ? void 0 : p.name) === plan_name;
      })) === null || _reactiveVarData$plan7 === void 0 ? void 0 : _reactiveVarData$plan7.premium), true, false, branding, true) // <CountAnimation
      //   end={
      //     reactiveVarData?.planData?.plans?.find(
      //       (p) => p?.name === plan_name,
      //     )?.premium?.totalPremium
      //   }
      //   duration={1}
      //   decimals={2}
      //   prefix={branding?.currency + ' '}
      //   formattingFn={(num) => {
      //     return Parse(num, true, false, branding, true);
      //   }}
      // />
      ));
    }
  } : null].filter(function (p) {
    return p;
  }) : [{
    type: 'render',
    colSpan: repeat,
    component: function component() {
      return /*#__PURE__*/React.createElement(Text, {
        severity: "neutral-darker",
        className: "flex justify-center text-2xl"
      }, "No CD Accounts Found");
    }
  }];
  return /*#__PURE__*/React.createElement(QuantaForm, null, /*#__PURE__*/React.createElement(InputGrid, {
    data: grid_data,
    repeat: repeat,
    titleType: "title",
    titleSeverity: "info"
  }));
}

var _excluded = ["setLoadingStep", "setCustomLoadingMessage", "setParentAlerts", "showSuccessMsg", "setShowWizardButtonPanel", "planName", "productCode", "productName", "planCode", "renewalMode", "REACTIVE_VAR_QUERY", "updateReactiveVar", "reactiveVarName", "modeOfOperation", "renderExpandedCards", "PayerType"];
function PayPremium(_ref) {
  var _data$2, _data$2$intermediaryD, _data$3, _data$3$intermediaryD, _reactiveVarData$prem, _PaymentTypeList$, _reactiveVarData$prem2, _reactiveVarData$prem3, _reactiveVarData$prem4, _reactiveVarData$prem5, _reactiveVarData$prem6, _reactiveVarData$prem7, _reactiveVarData$prem8, _reactiveVarData$prem9, _reactiveVarData$prem10, _reactiveVarData$prem11, _reactiveVarData$prem12, _reactiveVarData$prem13, _reactiveVarData$prem14, _reactiveVarData$prem15, _reactiveVarData$prem16, _reactiveVarData$prem17, _dateTimeData$datetim3, _reactiveVarData$prem18, _reactiveVarData$prem19, _reactiveVarData$prem20, _reactiveVarData$prem21, _dateTimeData$datetim5, _reactiveVarData$prem22, _reactiveVarData$prem23;

  _ref.setLoadingStep;
      var setCustomLoadingMessage = _ref.setCustomLoadingMessage,
      setParentAlerts = _ref.setParentAlerts,
      showSuccessMsg = _ref.showSuccessMsg,
      setShowWizardButtonPanel = _ref.setShowWizardButtonPanel,
      planName = _ref.planName,
      productCode = _ref.productCode,
      productName = _ref.productName;
      _ref.planCode;
      _ref.renewalMode;
      var REACTIVE_VAR_QUERY = _ref.REACTIVE_VAR_QUERY,
      updateReactiveVar = _ref.updateReactiveVar,
      reactiveVarName = _ref.reactiveVarName,
      modeOfOperation = _ref.modeOfOperation,
      renderExpandedCards = _ref.renderExpandedCards;
      _ref.PayerType;
      var props = _objectWithoutProperties(_ref, _excluded);

  var repeatForMobile = 1;
  var repeatForDesktop = 3;
  var mutateQuery = useMutationQuery();
  var params = useParams$1();
  var plan_name = planName ? planName : props !== null && props !== void 0 && props.plan_name ? props === null || props === void 0 ? void 0 : props.plan_name : params === null || params === void 0 ? void 0 : params.plan_name;
  var product_code = productCode ? productCode : params === null || params === void 0 ? void 0 : params.product_code;

  var _useQuery = useQuery(REACTIVE_VAR_QUERY, {
    onCompleted: function onCompleted(data) {
      var _data$;

      setShowWizardButtonPanel((_data$ = data["".concat(reactiveVarName)]) === null || _data$ === void 0 ? void 0 : _data$.isProposalApplicableForPayment);
    }
  }),
      loading = _useQuery.loading,
      error = _useQuery.error,
      data = _useQuery.data;

  var _useState = useState('Customer'),
      _useState2 = _slicedToArray(_useState, 2),
      PT = _useState2[0],
      setPT = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showterms = _useState4[0],
      setShow = _useState4[1];

  var _useQuery2 = useQuery(PAY_PREMIUM_LIST, {
    skip: data ? false : true,
    variables: {
      imdCode: (_data$2 = data["".concat(reactiveVarName)]) !== null && _data$2 !== void 0 && (_data$2$intermediaryD = _data$2.intermediaryDetails) !== null && _data$2$intermediaryD !== void 0 && _data$2$intermediaryD.code ? "".concat((_data$3 = data["".concat(reactiveVarName)]) === null || _data$3 === void 0 ? void 0 : (_data$3$intermediaryD = _data$3.intermediaryDetails) === null || _data$3$intermediaryD === void 0 ? void 0 : _data$3$intermediaryD.code) : ''
    }
  }),
      dropDownLoading = _useQuery2.loading,
      dropDownError = _useQuery2.error,
      dropDownData = _useQuery2.data;

  var _useQuery3 = useQuery(GET_CUSTOMER_TYPE_DOMAIN, {
    fetchPolicy: 'cache-first'
  }),
      loadingCustTypeDomain = _useQuery3.loading,
      errorCustTypeDomain = _useQuery3.error,
      dataCustTypeDomain = _useQuery3.data;

  var _useQuery4 = useQuery(CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL, {
    fetchPolicy: 'cache-first'
  }),
      dropDownLoadingCustomer = _useQuery4.loading,
      errorDownDetailsCustomer = _useQuery4.error,
      dropDownDetailsCustomer = _useQuery4.data;

  var _useQuery5 = useQuery(GET_DATE_TIME),
      dateTimeLoading = _useQuery5.loading,
      errorTimeLoading = _useQuery5.error,
      dateTimeData = _useQuery5.data;

  var getDomainData = function getDomainData(domainArr, searchText, searchType, returnType) {
    return domainArr.find(function (d) {
      return d["".concat(searchType)] === searchText;
    }) ? domainArr.find(function (d) {
      return d["".concat(searchType)] === searchText;
    })["".concat(returnType)] : '';
  };

  var reformData = function reformData(val, returnType, isString) {
    return val && val.toString().trim() !== '' ? isString === undefined || isString === true ? "".concat(val) : val : returnType;
  };

  var repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop
  });

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      LD = _useState6[0],
      setLD = _useState6[1];

  var RenewPayPremiumForm = function RenewPayPremiumForm(_ref2) {
    var _plans$find, _plans$find$premium, _plans$find2, _data$4, _data$5, _data$5$planData, _data$5$planData$plan, _data$5$planData$plan2, _data$5$planData$plan3, _data$6, _data$6$planData, _data$6$planData$plan, _data$6$planData$plan2, _data$7, _data$7$premiumDetail, _data$7$premiumDetail2, _data$8, _data$8$premiumDetail, _data$8$premiumDetail2, _dateTimeData$datetim, _dateTimeData$datetim2;

    _ref2.validate;

    var _useQuantaFormikConte = useQuantaFormikContext(),
        values = _useQuantaFormikConte.values;
        _useQuantaFormikConte.setFieldValue;

    var paymentMethod = values.paymentMethod;
    var gridData = [{
      title: 'Payment Summary',
      grid_type: 'data',
      grid_data: [{
        text: /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(DataGridGroup, _objectSpread2({
          data: [{
            grid_data: [{
              label: 'Plan Name',
              text: /*#__PURE__*/React.createElement(Text, {
                type: "title",
                severity: "info"
              }, plan_name),
              colSpan: 2
            }, LD === '' ? {
              label: 'Annual Premium (inclusive of all taxes)',
              text: /*#__PURE__*/React.createElement(Text, {
                type: "larger",
                severity: "info",
                className: "space-x-2"
              }, /*#__PURE__*/React.createElement("span", null, Parse((plans === null || plans === void 0 ? void 0 : (_plans$find = plans.find(function (p) {
                return (p === null || p === void 0 ? void 0 : p.name) === plan_name;
              })) === null || _plans$find === void 0 ? void 0 : (_plans$find$premium = _plans$find.premium) === null || _plans$find$premium === void 0 ? void 0 : _plans$find$premium.totalPremium) || (plans === null || plans === void 0 ? void 0 : (_plans$find2 = plans.find(function (p) {
                return p.name === plan_name;
              })) === null || _plans$find2 === void 0 ? void 0 : _plans$find2.premium))))
            } : {
              label: 'Please wait',
              text: /*#__PURE__*/React.createElement(Text, {
                type: "larger",
                severity: "info",
                className: "space-x-2"
              }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
                icon: faSpinner,
                spin: true
              })), /*#__PURE__*/React.createElement("span", null, "Submitting......."))
            }]
          }]
        }, {
          flow: 'cols',
          repeat: repeat,
          gapX: 6,
          gapY: 0,
          spaceY: 2,
          size: 'full',
          textType: 'normal',
          useExpandablePaper: false
        }))),
        colSpan: repeat
      }]
    }].concat(_toConsumableArray((_data$4 = data["".concat(reactiveVarName)]) !== null && _data$4 !== void 0 && _data$4.isProposalApplicableForPayment ? [{
      title: /*#__PURE__*/React.createElement(React.Fragment, null, "Confirmation", ' ', /*#__PURE__*/React.createElement(Text, {
        severity: "error",
        type: "title"
      }, "*")),
      grid_data: [{
        type: 'checkbox',
        name: 'termsAndConditions',
        label: /*#__PURE__*/React.createElement("span", null, "I have read and agree to the", ' ', /*#__PURE__*/React.createElement("span", {
          className: "text-secondary underline cursor-pointer",
          onClick: function onClick(_) {
            return setShow(true);
          } //  <TermsAndConditions></TermsAndConditions>
          // window.open(
          //   `/quote/${product_code}/termsAndConditions`,
          //   '_blank',
          // )

        }, "Terms and Conditions"), ' ', "of the policy"),
        colSpan: repeat
      }]
    }, {
      title: /*#__PURE__*/React.createElement(React.Fragment, null, "Payer Details", ' ', /*#__PURE__*/React.createElement(Text, {
        severity: "error",
        type: "title"
      }, "*")),
      colSpan: repeat,
      grid_data: [{
        type: 'select',
        label: /*#__PURE__*/React.createElement(React.Fragment, null, "Payer Type ", /*#__PURE__*/React.createElement(Text, {
          severity: "error"
        }, "*")),
        name: 'payerType',
        size: 'large',
        onDataChange: setPT(values.payerType),
        colSpan: repeat === repeatForDesktop ? repeat - 2 : repeat,
        data: PayMethodPayerTypeList ? _toConsumableArray(PayMethodPayerTypeList === null || PayMethodPayerTypeList === void 0 ? void 0 : PayMethodPayerTypeList.map(function (payerType) {
          return {
            label: payerType !== null && payerType !== void 0 && payerType.value ? payerType === null || payerType === void 0 ? void 0 : payerType.value : '',
            value: payerType !== null && payerType !== void 0 && payerType.code ? payerType === null || payerType === void 0 ? void 0 : payerType.code : ''
          };
        })) : []
      }, {
        type: 'render',
        colSpan: repeat === repeatForDesktop ? repeat - 1 : repeat,
        component: function component() {
          var _reactiveVarData$prop, _reactiveVarData$prop2, _reactiveVarData$prop3, _reactiveVarData$prop4, _reactiveVarData$prop5, _reactiveVarData$prop6, _reactiveVarData$prop7, _reactiveVarData$prop8, _reactiveVarData$prop9, _reactiveVarData$prop10, _reactiveVarData$inte;

          return /*#__PURE__*/React.createElement("span", {
            className: "flex flex-col mb-4"
          }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Text, {
            type: "label"
          }, "Payer Name")), /*#__PURE__*/React.createElement("div", {
            className: "break-all"
          }, (values === null || values === void 0 ? void 0 : values.payerType) === getDomainData(PayMethodPayerTypeList, 'Customer', 'value', 'code') ? (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop === void 0 ? void 0 : _reactiveVarData$prop.customerType) === getDomainData(customerTypeList, 'Individual', 'value', 'code') ? [getDomainData(salutationList, reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop2 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop2 === void 0 ? void 0 : (_reactiveVarData$prop3 = _reactiveVarData$prop2.title) === null || _reactiveVarData$prop3 === void 0 ? void 0 : _reactiveVarData$prop3.trim(), 'code', 'value'), reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop4 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop4 === void 0 ? void 0 : (_reactiveVarData$prop5 = _reactiveVarData$prop4.firstName) === null || _reactiveVarData$prop5 === void 0 ? void 0 : _reactiveVarData$prop5.trim(), reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop6 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop6 === void 0 ? void 0 : (_reactiveVarData$prop7 = _reactiveVarData$prop6.middleName) === null || _reactiveVarData$prop7 === void 0 ? void 0 : _reactiveVarData$prop7.trim(), reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop8 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop8 === void 0 ? void 0 : (_reactiveVarData$prop9 = _reactiveVarData$prop8.lastName) === null || _reactiveVarData$prop9 === void 0 ? void 0 : _reactiveVarData$prop9.trim()].filter(function (n) {
            return n;
          }).join(' ') : reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop10 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop10 === void 0 ? void 0 : _reactiveVarData$prop10.orgName : reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$inte = reactiveVarData.intermediaryDetails) === null || _reactiveVarData$inte === void 0 ? void 0 : _reactiveVarData$inte.intermediaryName));
        }
      }]
    }, {
      title: /*#__PURE__*/React.createElement(React.Fragment, null, "Choose Payment Method", ' ', /*#__PURE__*/React.createElement(Text, {
        severity: "error",
        type: "title"
      }, "*")),
      colSpan: repeat,
      grid_data: [{
        type: repeat === repeatForDesktop ? 'radiogroup' : 'select',
        colSpan: repeat,
        className: 'mt-1',
        name: 'paymentMethod',
        data: PaymentTypeList ? _toConsumableArray(PaymentTypeList === null || PaymentTypeList === void 0 ? void 0 : PaymentTypeList.map(function (paymentMethod) {
          if ((values === null || values === void 0 ? void 0 : values.payerType) === getDomainData(PayMethodPayerTypeList, 'Intermediary', 'value', 'code') && (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.value) === 'CD Wallet') {
            return {
              label: paymentMethod !== null && paymentMethod !== void 0 && paymentMethod.value ? paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.value : '',
              value: paymentMethod !== null && paymentMethod !== void 0 && paymentMethod.code ? paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.code : ''
            };
          }

          if (reactiveVarData.renewalMandateDetails.renewalPaymentMandate === false || reactiveVarData.renewalMandateDetails.renewalPaymentMandate == 'No') {
            if ((values === null || values === void 0 ? void 0 : values.payerType) === getDomainData(PayMethodPayerTypeList, 'Customer', 'value', 'code') && reactiveVarData.proposalPaymentType !== 'OFFLINE') return {
              label: paymentMethod !== null && paymentMethod !== void 0 && paymentMethod.value ? paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.value : '',
              value: paymentMethod !== null && paymentMethod !== void 0 && paymentMethod.code ? paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.code : ''
            };
          } else {
            if ((values === null || values === void 0 ? void 0 : values.payerType) === getDomainData(PayMethodPayerTypeList, 'Customer', 'value', 'code') && reactiveVarData.proposalPaymentType !== 'OFFLINE' && (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.value) === 'Digilink') return {
              label: paymentMethod !== null && paymentMethod !== void 0 && paymentMethod.value ? paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.value : '',
              value: paymentMethod !== null && paymentMethod !== void 0 && paymentMethod.code ? paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.code : ''
            };
          }

          if ((values === null || values === void 0 ? void 0 : values.payerType) === getDomainData(PayMethodPayerTypeList, 'Customer', 'value', 'code') && reactiveVarData.proposalPaymentType === 'OFFLINE' && (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.value) !== 'Digilink' && (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.value) !== 'Offline Payment') return {
            label: paymentMethod !== null && paymentMethod !== void 0 && paymentMethod.value ? paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.value : '',
            value: paymentMethod !== null && paymentMethod !== void 0 && paymentMethod.code ? paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.code : ''
          };
        }).filter(function (p) {
          return p;
        })) : []
      }]
    }] : [{
      title: /*#__PURE__*/React.createElement(React.Fragment, null, "Confirmation", ' ', /*#__PURE__*/React.createElement(Text, {
        severity: "error",
        type: "title"
      }, "*")),
      grid_data: [{
        type: 'checkbox',
        name: 'termsAndConditions',
        label: /*#__PURE__*/React.createElement("span", null, "I have read and agree to the", ' ', /*#__PURE__*/React.createElement("span", {
          className: "text-secondary underline cursor-pointer",
          onClick: function onClick(_) {
            return setShow(true);
          } //  <TermsAndConditions></TermsAndConditions>
          // window.open(
          //   `/quote/${product_code}/termsAndConditions`,
          //   '_blank',
          // )

        }, "Terms and Conditions"), ' ', "of the policy"),
        colSpan: repeat
      }]
    }, {
      title: /*#__PURE__*/React.createElement(React.Fragment, null, "Payer Details", ' ', /*#__PURE__*/React.createElement(Text, {
        severity: "error",
        type: "title"
      }, "*")),
      colSpan: repeat,
      grid_data: [{
        type: 'select',
        label: /*#__PURE__*/React.createElement(React.Fragment, null, "Payer Type ", /*#__PURE__*/React.createElement(Text, {
          severity: "error"
        }, "*")),
        name: 'payerType',
        size: 'large',
        onDataChange: setPT(values.payerType),
        colSpan: repeat === repeatForDesktop ? repeat - 2 : repeat,
        data: PayMethodPayerTypeList ? _toConsumableArray(PayMethodPayerTypeList === null || PayMethodPayerTypeList === void 0 ? void 0 : PayMethodPayerTypeList.map(function (payerType) {
          return {
            label: payerType !== null && payerType !== void 0 && payerType.value ? payerType === null || payerType === void 0 ? void 0 : payerType.value : '',
            value: payerType !== null && payerType !== void 0 && payerType.code ? payerType === null || payerType === void 0 ? void 0 : payerType.code : ''
          };
        })) : []
      }, {
        type: 'render',
        colSpan: repeat === repeatForDesktop ? repeat - 1 : repeat,
        component: function component() {
          var _reactiveVarData$prop11, _reactiveVarData$prop12, _reactiveVarData$prop13, _reactiveVarData$prop14, _reactiveVarData$prop15, _reactiveVarData$prop16, _reactiveVarData$prop17, _reactiveVarData$prop18, _reactiveVarData$prop19, _reactiveVarData$prop20, _reactiveVarData$inte2;

          return /*#__PURE__*/React.createElement("span", {
            className: "flex flex-col mb-4"
          }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Text, {
            type: "label"
          }, "Payer Name")), /*#__PURE__*/React.createElement("div", {
            className: "break-all"
          }, (values === null || values === void 0 ? void 0 : values.payerType) === getDomainData(PayMethodPayerTypeList, 'Customer', 'value', 'code') ? (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop11 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop11 === void 0 ? void 0 : _reactiveVarData$prop11.customerType) === getDomainData(customerTypeList, 'Individual', 'value', 'code') ? [getDomainData(salutationList, reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop12 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop12 === void 0 ? void 0 : (_reactiveVarData$prop13 = _reactiveVarData$prop12.title) === null || _reactiveVarData$prop13 === void 0 ? void 0 : _reactiveVarData$prop13.trim(), 'code', 'value'), reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop14 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop14 === void 0 ? void 0 : (_reactiveVarData$prop15 = _reactiveVarData$prop14.firstName) === null || _reactiveVarData$prop15 === void 0 ? void 0 : _reactiveVarData$prop15.trim(), reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop16 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop16 === void 0 ? void 0 : (_reactiveVarData$prop17 = _reactiveVarData$prop16.middleName) === null || _reactiveVarData$prop17 === void 0 ? void 0 : _reactiveVarData$prop17.trim(), reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop18 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop18 === void 0 ? void 0 : (_reactiveVarData$prop19 = _reactiveVarData$prop18.lastName) === null || _reactiveVarData$prop19 === void 0 ? void 0 : _reactiveVarData$prop19.trim()].filter(function (n) {
            return n;
          }).join(' ') : reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop20 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop20 === void 0 ? void 0 : _reactiveVarData$prop20.orgName : reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$inte2 = reactiveVarData.intermediaryDetails) === null || _reactiveVarData$inte2 === void 0 ? void 0 : _reactiveVarData$inte2.intermediaryName));
        }
      }]
    }, {
      title: /*#__PURE__*/React.createElement(React.Fragment, null, "Choose Payment Method", ' ', /*#__PURE__*/React.createElement(Text, {
        severity: "error",
        type: "title"
      }, "*")),
      colSpan: repeat,
      grid_data: [{
        type: repeat === repeatForDesktop ? 'radiogroup' : 'select',
        colSpan: repeat,
        className: 'mt-1',
        name: 'paymentMethod',
        data: PaymentTypeList ? _toConsumableArray(PaymentTypeList === null || PaymentTypeList === void 0 ? void 0 : PaymentTypeList.map(function (paymentMethod) {
          if ((values === null || values === void 0 ? void 0 : values.payerType) === getDomainData(PayMethodPayerTypeList, 'Intermediary', 'value', 'code') && (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.value) === 'CD Wallet') {
            return {
              label: paymentMethod !== null && paymentMethod !== void 0 && paymentMethod.value ? paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.value : '',
              value: paymentMethod !== null && paymentMethod !== void 0 && paymentMethod.code ? paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.code : ''
            };
          } else if ((values === null || values === void 0 ? void 0 : values.payerType) === getDomainData(PayMethodPayerTypeList, 'Intermediary', 'value', 'code') && (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.value) === 'Tag existing Receipt') {
            return {
              label: paymentMethod !== null && paymentMethod !== void 0 && paymentMethod.value ? paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.value : '',
              value: paymentMethod !== null && paymentMethod !== void 0 && paymentMethod.code ? paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.code : ''
            };
          }

          if (reactiveVarData.renewalMandateDetails.renewalPaymentMandate === false || reactiveVarData.renewalMandateDetails.renewalPaymentMandate == 'No') {
            if ((values === null || values === void 0 ? void 0 : values.payerType) === getDomainData(PayMethodPayerTypeList, 'Customer', 'value', 'code') && reactiveVarData.proposalPaymentType !== 'OFFLINE') return {
              label: paymentMethod !== null && paymentMethod !== void 0 && paymentMethod.value ? paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.value : '',
              value: paymentMethod !== null && paymentMethod !== void 0 && paymentMethod.code ? paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.code : ''
            };
          } else {
            if ((values === null || values === void 0 ? void 0 : values.payerType) === getDomainData(PayMethodPayerTypeList, 'Customer', 'value', 'code') && reactiveVarData.proposalPaymentType !== 'OFFLINE' && (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.value) === 'Digilink') return {
              label: paymentMethod !== null && paymentMethod !== void 0 && paymentMethod.value ? paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.value : '',
              value: paymentMethod !== null && paymentMethod !== void 0 && paymentMethod.code ? paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.code : ''
            };
          }

          if ((values === null || values === void 0 ? void 0 : values.payerType) === getDomainData(PayMethodPayerTypeList, 'Customer', 'value', 'code') && reactiveVarData.proposalPaymentType === 'OFFLINE' && (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.value) !== 'Digilink' && (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.value) !== 'Offline Payment') return {
            label: paymentMethod !== null && paymentMethod !== void 0 && paymentMethod.value ? paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.value : '',
            value: paymentMethod !== null && paymentMethod !== void 0 && paymentMethod.code ? paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.code : ''
          };
        }).filter(function (p) {
          return p;
        })) : []
      }]
    }])).filter(function (d) {
      return d;
    });
    var other_props = {
      flow: 'cols',
      repeat: repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      textType: 'normal'
    };
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(QuantaForm, {
      className: "space-y-4"
    }, /*#__PURE__*/React.createElement(MixedGridGroup, _objectSpread2({
      data: gridData
    }, other_props))), // data[`${reactiveVarName}`]
    //   ?.isProposalApplicableForPayment ?
    paymentMethod === getDomainData(PaymentTypeList, 'Offline Payment', 'value', 'code') && reactiveVarData.proposalPaymentType !== 'OFFLINE' && reactiveVarData.renewalMandateDetails.renewalPaymentMandate === false || reactiveVarData.renewalMandateDetails.renewalPaymentMandate == 'No' && (values === null || values === void 0 ? void 0 : values.payerType) === getDomainData(PayMethodPayerTypeList, 'Customer', 'value', 'code') ? /*#__PURE__*/React.createElement("span", {
      className: "mt-8"
    }, /*#__PURE__*/React.createElement(OnlinePayment, {
      totalPremium: ((_data$5 = data["".concat(reactiveVarName)]) === null || _data$5 === void 0 ? void 0 : (_data$5$planData = _data$5.planData) === null || _data$5$planData === void 0 ? void 0 : (_data$5$planData$plan = _data$5$planData.plans) === null || _data$5$planData$plan === void 0 ? void 0 : (_data$5$planData$plan2 = _data$5$planData$plan.find(function (p) {
        return (p === null || p === void 0 ? void 0 : p.name) === plan_name;
      })) === null || _data$5$planData$plan2 === void 0 ? void 0 : (_data$5$planData$plan3 = _data$5$planData$plan2.premium) === null || _data$5$planData$plan3 === void 0 ? void 0 : _data$5$planData$plan3.totalPremium) || ((_data$6 = data["".concat(reactiveVarName)]) === null || _data$6 === void 0 ? void 0 : (_data$6$planData = _data$6.planData) === null || _data$6$planData === void 0 ? void 0 : (_data$6$planData$plan = _data$6$planData.plans) === null || _data$6$planData$plan === void 0 ? void 0 : (_data$6$planData$plan2 = _data$6$planData$plan.find(function (p) {
        return (p === null || p === void 0 ? void 0 : p.name) === plan_name;
      })) === null || _data$6$planData$plan2 === void 0 ? void 0 : _data$6$planData$plan2.premium),
      transactionId: (_data$7 = data["".concat(reactiveVarName)]) === null || _data$7 === void 0 ? void 0 : (_data$7$premiumDetail = _data$7.premiumDetails) === null || _data$7$premiumDetail === void 0 ? void 0 : (_data$7$premiumDetail2 = _data$7$premiumDetail.onlinePayment) === null || _data$7$premiumDetail2 === void 0 ? void 0 : _data$7$premiumDetail2.transactionId,
      isTransactionIdVerified: (_data$8 = data["".concat(reactiveVarName)]) === null || _data$8 === void 0 ? void 0 : (_data$8$premiumDetail = _data$8.premiumDetails) === null || _data$8$premiumDetail === void 0 ? void 0 : (_data$8$premiumDetail2 = _data$8$premiumDetail.onlinePayment) === null || _data$8$premiumDetail2 === void 0 ? void 0 : _data$8$premiumDetail2.isTransactionIdVerified
    })) : paymentMethod === getDomainData(PaymentTypeList, 'Digilink', 'value', 'code') ? /*#__PURE__*/React.createElement(Digilink, {
      reactiveVarName: reactiveVarName,
      REACTIVE_VAR_QUERY: REACTIVE_VAR_QUERY
    }) : paymentMethod === getDomainData(PaymentTypeList, 'CD Wallet', 'value', 'code') //   &&
    // values?.payerType ===
    //   getDomainData(
    //     PayMethodPayerTypeList,
    //     'Intermediary',
    //     'value',
    //     'code',
    //   )
    ?
    /*#__PURE__*/
    React.createElement("span", {
      className: "mt-8"
    }, /*#__PURE__*/React.createElement(CdWalletHealth, {
      planName: plan_name,
      REACTIVE_VAR_QUERY: REACTIVE_VAR_QUERY,
      reactiveVarName: reactiveVarName,
      PT: PT,
      productCode: product_code
    })) : paymentMethod === getDomainData(PaymentTypeList, 'Cheque', 'value', 'code') && (values === null || values === void 0 ? void 0 : values.payerType) === getDomainData(PayMethodPayerTypeList, 'Customer', 'value', 'code') ? /*#__PURE__*/React.createElement("span", {
      className: "mt-8"
    }, /*#__PURE__*/React.createElement(Cheque, {
      ChequeTypeList: ChequeTypeList,
      data: {
        maxDate: dateTimeData === null || dateTimeData === void 0 ? void 0 : (_dateTimeData$datetim = dateTimeData.datetimeValue) === null || _dateTimeData$datetim === void 0 ? void 0 : _dateTimeData$datetim.date
      },
      renderExpandedCards: renderExpandedCards
    }), ' ') : paymentMethod === getDomainData(PaymentTypeList, 'Demand Draft', 'value', 'code') && (values === null || values === void 0 ? void 0 : values.payerType) === getDomainData(PayMethodPayerTypeList, 'Customer', 'value', 'code') ? /*#__PURE__*/React.createElement("span", {
      className: "mt-8"
    }, /*#__PURE__*/React.createElement(DemandDraft, {
      data: {
        maxDate: dateTimeData === null || dateTimeData === void 0 ? void 0 : (_dateTimeData$datetim2 = dateTimeData.datetimeValue) === null || _dateTimeData$datetim2 === void 0 ? void 0 : _dateTimeData$datetim2.date
      },
      renderExpandedCards: renderExpandedCards
    }), ' ') : null);
  };

  if (loading || dropDownLoading || loadingCustTypeDomain || dropDownLoadingCustomer || dateTimeLoading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "min-h-screen"
    }, /*#__PURE__*/React.createElement(Loading, null));
  }

  if (error || dropDownError || errorCustTypeDomain || errorDownDetailsCustomer || errorTimeLoading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "min-h-screen"
    }, /*#__PURE__*/React.createElement(Error, {
      error: error || dropDownError || errorCustTypeDomain || errorDownDetailsCustomer || errorTimeLoading
    }));
  } //const { reactiveVarData } = data;


  var reactiveVarData = data["".concat(reactiveVarName)];
  var planData = reactiveVarData.planData;
  var plans = planData.plans;
  var PayMethodPayerTypeList = dropDownData.PayMethodPayerTypeList,
      PaymentTypeList = dropDownData.PaymentTypeList,
      ChequeTypeList = dropDownData.ChequeTypeList;
  var customerTypeList = dataCustTypeDomain.customerTypeList;
  var salutationList = dropDownDetailsCustomer.salutationList;

  var validate = function validate(values) {
    var _reactiveVarData$plan21, _reactiveVarData$plan22, _reactiveVarData$plan23, _reactiveVarData$plan24, _reactiveVarData$plan25;

    var paymentAmount = 0;
    var errors = {},
        errorCount = 0;

    if (!(values !== null && values !== void 0 && values.payerType)) {
      errors.payerType = '* Required';
      errorCount += 1;
    }

    if ((values === null || values === void 0 ? void 0 : values.payerType) === 'Intermediary' && reactiveVarData.renewalMandateDetails.renewalPaymentMandate === true) {
      // errors.payerType={};
      errors.payerName = ' As Renewal manadate has been opted , Intermediary Payertype is not applicable ';
      errorCount += 1; //Object.keys(errors.payerType).length;
    }

    if (!(values !== null && values !== void 0 && values.paymentMethod)) {
      errors.paymentMethod = '* Required';
    }

    if ((values === null || values === void 0 ? void 0 : values.paymentMethod) === getDomainData(PaymentTypeList, 'Cheque', 'value', 'code')) {
      var _values$cheque;

      errors.cheque = values === null || values === void 0 ? void 0 : (_values$cheque = values.cheque) === null || _values$cheque === void 0 ? void 0 : _values$cheque.map(function (_) {
        return {};
      });
      values === null || values === void 0 ? void 0 : values.cheque.forEach(function (_, idx) {
        var _values$cheque$idx;

        paymentAmount += parseFloat(values === null || values === void 0 ? void 0 : values.cheque[idx].paymentAmount);

        if (!(values !== null && values !== void 0 && (_values$cheque$idx = values.cheque[idx]) !== null && _values$cheque$idx !== void 0 && _values$cheque$idx.ifscCode) && (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.isProposalApplicableForPayment) === true) {
          errors.cheque[idx] = _objectSpread2(_objectSpread2({}, errors.cheque[idx]), {}, {
            ifscCode: '* Required'
          });
        }

        if (values !== null && values !== void 0 && values.cheque[idx].ifscCode && !(values !== null && values !== void 0 && values.cheque[idx].ifscCode.match(/^[a-zA-Z0-9]+$/))) {
          errors.cheque[idx] = _objectSpread2(_objectSpread2({}, errors.cheque[idx]), {}, {
            ifscCode: '* IFSC Code cannot contain special characters'
          });
        }

        if (!(values !== null && values !== void 0 && values.cheque[idx].branchName) && (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.isProposalApplicableForPayment) === true) {
          errors.cheque[idx] = _objectSpread2(_objectSpread2({}, errors.cheque[idx]), {}, {
            branchName: '* Required'
          });
        }

        if (!(values !== null && values !== void 0 && values.cheque[idx].bankName) && (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.isProposalApplicableForPayment) === true) {
          errors.cheque[idx] = _objectSpread2(_objectSpread2({}, errors.cheque[idx]), {}, {
            bankName: '* Required'
          });
        } // if (!values?.cheque[idx].chequeType) {
        //   errors.cheque[idx] = {
        //     ...errors.cheque[idx],
        //     chequeType: '* Required',
        //   };
        // }


        if (!(values !== null && values !== void 0 && values.cheque[idx].chequeDate) && (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.isProposalApplicableForPayment) === true) {
          errors.cheque[idx] = _objectSpread2(_objectSpread2({}, errors.cheque[idx]), {}, {
            chequeDate: '* Required'
          });
        }

        if (!(values !== null && values !== void 0 && values.cheque[idx].chequeNumber) && (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.isProposalApplicableForPayment) === true) {
          errors.cheque[idx] = _objectSpread2(_objectSpread2({}, errors.cheque[idx]), {}, {
            chequeNumber: '* Required'
          });
        }

        if (values !== null && values !== void 0 && values.cheque[idx].chequeNumber && (values === null || values === void 0 ? void 0 : values.cheque[idx].chequeNumber.length) !== 6) {
          errors.cheque[idx] = _objectSpread2(_objectSpread2({}, errors.cheque[idx]), {}, {
            chequeNumber: '* Cheque number must be of 6 digits'
          });
        }

        if (!(values !== null && values !== void 0 && values.cheque[idx].paymentAmount) && (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.isProposalApplicableForPayment) === true) {
          errors.cheque[idx] = _objectSpread2(_objectSpread2({}, errors.cheque[idx]), {}, {
            paymentAmount: '* Required'
          });
        }

        if (!(values !== null && values !== void 0 && values.cheque[idx].branchLocation) && (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.isProposalApplicableForPayment) === true) {
          errors.cheque[idx] = _objectSpread2(_objectSpread2({}, errors.cheque[idx]), {}, {
            branchLocation: '* Required'
          });
        }
      });
      values === null || values === void 0 ? void 0 : values.cheque.forEach(function (_, idx) {
        errorCount += Object.keys(errors.cheque[idx]).length;
      });
    } else if ((values === null || values === void 0 ? void 0 : values.paymentMethod) === getDomainData(PaymentTypeList, 'Demand Draft', 'value', 'code')) {
      var _values$demandDraft;

      errors.demandDraft = values === null || values === void 0 ? void 0 : (_values$demandDraft = values.demandDraft) === null || _values$demandDraft === void 0 ? void 0 : _values$demandDraft.map(function (demandDraft) {
        return {};
      });
      values === null || values === void 0 ? void 0 : values.demandDraft.forEach(function (_, idx) {
        paymentAmount += parseFloat(values === null || values === void 0 ? void 0 : values.demandDraft[idx].paymentAmount);

        if (!(values !== null && values !== void 0 && values.demandDraft[idx].ifscCode) && (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.isProposalApplicableForPayment) === true) {
          errors.demandDraft[idx] = _objectSpread2(_objectSpread2({}, errors.demandDraft[idx]), {}, {
            ifscCode: '* Required'
          });
        }

        if (values !== null && values !== void 0 && values.demandDraft[idx].ifscCode && !(values !== null && values !== void 0 && values.demandDraft[idx].ifscCode.match(/^[a-zA-Z0-9\s]+$/))) {
          errors.demandDraft[idx] = _objectSpread2(_objectSpread2({}, errors.demandDraft[idx]), {}, {
            ifscCode: '* IFSC Code cannot contain special characters'
          });
        }

        if (!(values !== null && values !== void 0 && values.demandDraft[idx].branchName)) {
          errors.demandDraft[idx] = _objectSpread2(_objectSpread2({}, errors.demandDraft[idx]), {}, {
            branchName: '* Required'
          });
        }

        if (!(values !== null && values !== void 0 && values.demandDraft[idx].bankName) && (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.isProposalApplicableForPayment) === true) {
          errors.demandDraft[idx] = _objectSpread2(_objectSpread2({}, errors.demandDraft[idx]), {}, {
            bankName: '* Required'
          });
        }

        if (!(values !== null && values !== void 0 && values.demandDraft[idx].ddDate) && (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.isProposalApplicableForPayment) === true) {
          errors.demandDraft[idx] = _objectSpread2(_objectSpread2({}, errors.demandDraft[idx]), {}, {
            ddDate: '* Required'
          });
        }

        if (!(values !== null && values !== void 0 && values.demandDraft[idx].ddNumber) && (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.isProposalApplicableForPayment) === true) {
          errors.demandDraft[idx] = _objectSpread2(_objectSpread2({}, errors.demandDraft[idx]), {}, {
            ddNumber: '* Required'
          });
        }

        if (values !== null && values !== void 0 && values.demandDraft[idx].ddNumber && (values === null || values === void 0 ? void 0 : values.demandDraft[idx].ddNumber.length) !== 6) {
          errors.demandDraft[idx] = _objectSpread2(_objectSpread2({}, errors.demandDraft[idx]), {}, {
            ddNumber: '* DD number must be of 6 digits'
          });
        }

        if (!(values !== null && values !== void 0 && values.demandDraft[idx].paymentAmount) && (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.isProposalApplicableForPayment) === true) {
          errors.demandDraft[idx] = _objectSpread2(_objectSpread2({}, errors.demandDraft[idx]), {}, {
            paymentAmount: '* Required'
          });
        }

        if (!(values !== null && values !== void 0 && values.demandDraft[idx].branchLocation) && (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.isProposalApplicableForPayment) === true) {
          errors.demandDraft[idx] = _objectSpread2(_objectSpread2({}, errors.demandDraft[idx]), {}, {
            branchLocation: '* Required'
          });
        }

        values === null || values === void 0 ? void 0 : values.demandDraft.forEach(function (_, idx) {
          errorCount += Object.keys(errors.demandDraft[idx]).length;
        });
      });
    } else if ((values === null || values === void 0 ? void 0 : values.paymentMethod) === getDomainData(PaymentTypeList, 'Offline Payment', 'value', 'code')) {
      var _reactiveVarData$plan, _reactiveVarData$plan2, _reactiveVarData$plan3, _reactiveVarData$plan4, _values$onlinePayment, _values$onlinePayment2;

      paymentAmount = (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$plan = reactiveVarData.planData) === null || _reactiveVarData$plan === void 0 ? void 0 : (_reactiveVarData$plan2 = _reactiveVarData$plan.plans) === null || _reactiveVarData$plan2 === void 0 ? void 0 : _reactiveVarData$plan2.find(function (p) {
        return (p === null || p === void 0 ? void 0 : p.name) === plan_name;
      }).premium.totalPremium) || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$plan3 = reactiveVarData.planData) === null || _reactiveVarData$plan3 === void 0 ? void 0 : (_reactiveVarData$plan4 = _reactiveVarData$plan3.plans) === null || _reactiveVarData$plan4 === void 0 ? void 0 : _reactiveVarData$plan4.find(function (p) {
        return (p === null || p === void 0 ? void 0 : p.name) === plan_name;
      }).premium);
      errors.onlinePayment = {};

      if (!(values !== null && values !== void 0 && values.onlinePayment.transactionId) && (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.isProposalApplicableForPayment) === true) {
        errors.onlinePayment.transactionId = '* Required';
      }

      if (values.onlinePayment.transactionId && ((_values$onlinePayment = values.onlinePayment.transactionId.toString()) === null || _values$onlinePayment === void 0 ? void 0 : _values$onlinePayment.length) < 8 //  ||
      //    !values.onlinePayment.transactionId.toString().match(/^[0-9]+$/)
      ) {
        errors.onlinePayment.transactionId = 'Invalid Transaction ID ';
      }

      if (values !== null && values !== void 0 && (_values$onlinePayment2 = values.onlinePayment) !== null && _values$onlinePayment2 !== void 0 && _values$onlinePayment2.transactionId && !(values !== null && values !== void 0 && values.onlinePayment.isTransactionIdVerified)) {
        errors.onlinePayment.isTransactionIdVerified = 'Verify the transaction ID before proceeding';
      }

      errorCount += Object.keys(errors.onlinePayment).length;
    } else if ((values === null || values === void 0 ? void 0 : values.paymentMethod) === getDomainData(PaymentTypeList, 'CD Wallet', 'value', 'code')) {
      var _reactiveVarData$plan5, _reactiveVarData$plan6, _reactiveVarData$plan7, _reactiveVarData$plan8, _reactiveVarData$plan9, _reactiveVarData$plan10, _reactiveVarData$plan11, _values$cdWallet;

      paymentAmount = (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$plan5 = reactiveVarData.planData) === null || _reactiveVarData$plan5 === void 0 ? void 0 : (_reactiveVarData$plan6 = _reactiveVarData$plan5.plans) === null || _reactiveVarData$plan6 === void 0 ? void 0 : (_reactiveVarData$plan7 = _reactiveVarData$plan6.find(function (p) {
        return (p === null || p === void 0 ? void 0 : p.name) === plan_name;
      })) === null || _reactiveVarData$plan7 === void 0 ? void 0 : (_reactiveVarData$plan8 = _reactiveVarData$plan7.premium) === null || _reactiveVarData$plan8 === void 0 ? void 0 : _reactiveVarData$plan8.totalPremium) || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$plan9 = reactiveVarData.planData) === null || _reactiveVarData$plan9 === void 0 ? void 0 : (_reactiveVarData$plan10 = _reactiveVarData$plan9.plans) === null || _reactiveVarData$plan10 === void 0 ? void 0 : (_reactiveVarData$plan11 = _reactiveVarData$plan10.find(function (p) {
        return (p === null || p === void 0 ? void 0 : p.name) === plan_name;
      })) === null || _reactiveVarData$plan11 === void 0 ? void 0 : _reactiveVarData$plan11.premium);
      errors.cdWallet = {};

      if ((values === null || values === void 0 ? void 0 : (_values$cdWallet = values.cdWallet) === null || _values$cdWallet === void 0 ? void 0 : _values$cdWallet.cdAccountCount) === 0) {
        errors.cdWallet.cdAccountCount = 'No CD Accounts Found. Proceed with any other Payment methods available';
      } else {
        var _reactiveVarData$plan12, _reactiveVarData$plan13, _reactiveVarData$plan14, _reactiveVarData$plan15, _reactiveVarData$plan16;

        if (!(values !== null && values !== void 0 && values.cdWallet.cdAccountNo)) {
          errors.cdWallet.cdAccountNo = '* Required';
        }

        if (values !== null && values !== void 0 && values.cdWallet.cdAccountBalance && parseFloat(values === null || values === void 0 ? void 0 : values.cdWallet.cdAccountBalance) < ((reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$plan12 = reactiveVarData.planData) === null || _reactiveVarData$plan12 === void 0 ? void 0 : (_reactiveVarData$plan13 = _reactiveVarData$plan12.plans) === null || _reactiveVarData$plan13 === void 0 ? void 0 : _reactiveVarData$plan13.find(function (p) {
          return (p === null || p === void 0 ? void 0 : p.name) === plan_name;
        }).premium.totalPremium) || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$plan14 = reactiveVarData.planData) === null || _reactiveVarData$plan14 === void 0 ? void 0 : (_reactiveVarData$plan15 = _reactiveVarData$plan14.plans) === null || _reactiveVarData$plan15 === void 0 ? void 0 : (_reactiveVarData$plan16 = _reactiveVarData$plan15.find(function (p) {
          return (p === null || p === void 0 ? void 0 : p.name) === plan_name;
        })) === null || _reactiveVarData$plan16 === void 0 ? void 0 : _reactiveVarData$plan16.premium))) {
          errors.cdWallet.cdAccountBalance = '* Insufficient CD Account Balance';
          paymentAmount = 0;
        }
      }

      errorCount += Object.keys(errors.cdWallet).length;
    } else {
      var _reactiveVarData$plan17, _reactiveVarData$plan18, _reactiveVarData$plan19, _reactiveVarData$plan20;

      paymentAmount = (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$plan17 = reactiveVarData.planData) === null || _reactiveVarData$plan17 === void 0 ? void 0 : (_reactiveVarData$plan18 = _reactiveVarData$plan17.plans) === null || _reactiveVarData$plan18 === void 0 ? void 0 : _reactiveVarData$plan18.find(function (p) {
        return (p === null || p === void 0 ? void 0 : p.name) === plan_name;
      }).premium.totalPremium) || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$plan19 = reactiveVarData.planData) === null || _reactiveVarData$plan19 === void 0 ? void 0 : (_reactiveVarData$plan20 = _reactiveVarData$plan19.plans) === null || _reactiveVarData$plan20 === void 0 ? void 0 : _reactiveVarData$plan20.find(function (p) {
        return (p === null || p === void 0 ? void 0 : p.name) === plan_name;
      }).premium);
    }

    var payvalue;
    var premiumVal = (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$plan21 = reactiveVarData.planData) === null || _reactiveVarData$plan21 === void 0 ? void 0 : (_reactiveVarData$plan22 = _reactiveVarData$plan21.plans) === null || _reactiveVarData$plan22 === void 0 ? void 0 : (_reactiveVarData$plan23 = _reactiveVarData$plan22.find(function (p) {
      return (p === null || p === void 0 ? void 0 : p.name) === plan_name;
    }).premium) === null || _reactiveVarData$plan23 === void 0 ? void 0 : _reactiveVarData$plan23.totalPremium) || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$plan24 = reactiveVarData.planData) === null || _reactiveVarData$plan24 === void 0 ? void 0 : (_reactiveVarData$plan25 = _reactiveVarData$plan24.plans) === null || _reactiveVarData$plan25 === void 0 ? void 0 : _reactiveVarData$plan25.find(function (p) {
      return (p === null || p === void 0 ? void 0 : p.name) === plan_name;
    }).premium); // console.log('paymentamount',paymentAmount)

    if (paymentAmount >= premiumVal - 0 || paymentAmount === premiumVal - 1 || paymentAmount === premiumVal - 2 || paymentAmount === premiumVal - 3 || paymentAmount === premiumVal - 4 || paymentAmount === premiumVal - 5) {
      payvalue = true;
    } // console.log('payvalue',payvalue)


    if (payvalue !== true && (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.isProposalApplicableForPayment) === true) {
      errors.totalPaymentAmount = 'Total payment amount should be atleast equal to the total premium amount or balance is not sufficient.';
      errorCount += 1;
    }

    if (!(values !== null && values !== void 0 && values.termsAndConditions)) {
      errors.termsAndConditions = '* Required';
      errorCount += 1;
    }

    if (errorCount === 0 && payvalue === true // &&
    // paymentAmount >=
    //   reactiveVarData?.planData?.plans?.find(
    //     (p) => p?.name === plan_name,
    //   ).premium.totalPremium
    ) {
        errors = {};
      }

    return errors;
  };

  var renewPolicyVariables = function renewPolicyVariables(values) {
    var _data$9, _data$9$intermediaryD, _data$10, _data$10$intermediary, _data$11, _data$11$intermediary, _data$12, _data$12$intermediary, _data$13, _data$13$intermediary, _data$14, _data$14$intermediary, _reactiveVarData$prop21, _reactiveVarData$plan38, _reactiveVarData$plan39, _reactiveVarData$plan40, _reactiveVarData$plan41, _reactiveVarData$plan42, _reactiveVarData$plan43, _reactiveVarData$plan44;

    var getReceiptDetails = function getReceiptDetails() {
      var receiptArr = [];

      if ((values === null || values === void 0 ? void 0 : values.paymentMethod) === getDomainData(PaymentTypeList, 'Cheque', 'value', 'code')) {
        values === null || values === void 0 ? void 0 : values.cheque.forEach(function (_, idx) {
          receiptArr.push({
            paymentMode: values === null || values === void 0 ? void 0 : values.paymentMethod,
            receiptAmount: parseFloat(values === null || values === void 0 ? void 0 : values.cheque[idx].paymentAmount),
            cdAccNumber: null,
            cheqDDTransReferenceNo: values === null || values === void 0 ? void 0 : values.cheque[idx].chequeNumber,
            cheqDDTransDate: values === null || values === void 0 ? void 0 : values.cheque[idx].chequeDate,
            // chequeType:values?.cheque[idx].chequeType ,//values?.cheque[idx].chequeType,
            //chequeType: values?.cheque[idx].bankName =='KOTAK' ? '0' :'1', match(/^[0-9]+$/,,match(/^[0-9]+$/))
            // chequeType: values?.cheque[idx].bankName.toLowerCase().search("kotak") ? '0' :'1', 
            chequeType: "",
            ifscCode: values === null || values === void 0 ? void 0 : values.cheque[idx].ifscCode,
            bankName: values === null || values === void 0 ? void 0 : values.cheque[idx].bankName,
            bankCode: values === null || values === void 0 ? void 0 : values.cheque[idx].bankCode,
            bankLocation: values === null || values === void 0 ? void 0 : values.cheque[idx].branchLocation,
            branchName: values === null || values === void 0 ? void 0 : values.cheque[idx].branchName,
            gstNumber: null
          });
        });
      } else if ((values === null || values === void 0 ? void 0 : values.paymentMethod) === getDomainData(PaymentTypeList, 'Demand Draft', 'value', 'code')) {
        values === null || values === void 0 ? void 0 : values.demandDraft.forEach(function (_, idx) {
          receiptArr.push({
            paymentMode: values === null || values === void 0 ? void 0 : values.paymentMethod,
            receiptAmount: parseFloat(values === null || values === void 0 ? void 0 : values.demandDraft[idx].paymentAmount),
            cdAccNumber: null,
            cheqDDTransReferenceNo: values === null || values === void 0 ? void 0 : values.demandDraft[idx].ddNumber,
            cheqDDTransDate: values === null || values === void 0 ? void 0 : values.demandDraft[idx].ddDate,
            chequeType: null,
            ifscCode: values === null || values === void 0 ? void 0 : values.demandDraft[idx].ifscCode,
            bankName: values === null || values === void 0 ? void 0 : values.demandDraft[idx].bankName,
            bankCode: values === null || values === void 0 ? void 0 : values.demandDraft[idx].bankCode,
            bankLocation: values === null || values === void 0 ? void 0 : values.demandDraft[idx].branchLocation,
            branchName: values === null || values === void 0 ? void 0 : values.demandDraft[idx].branchName,
            gstNumber: null
          });
        });
      } else if ((values === null || values === void 0 ? void 0 : values.paymentMethod) === getDomainData(PaymentTypeList, 'Offline Payment', 'value', 'code')) {
        var _reactiveVarData$plan26, _reactiveVarData$plan27, _reactiveVarData$plan28, _reactiveVarData$plan29;

        receiptArr.push({
          paymentMode: values === null || values === void 0 ? void 0 : values.paymentMethod,
          receiptAmount: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$plan26 = reactiveVarData.planData) === null || _reactiveVarData$plan26 === void 0 ? void 0 : (_reactiveVarData$plan27 = _reactiveVarData$plan26.plans) === null || _reactiveVarData$plan27 === void 0 ? void 0 : _reactiveVarData$plan27.find(function (p) {
            return (p === null || p === void 0 ? void 0 : p.name) === plan_name;
          }).premium.totalPremium) || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$plan28 = reactiveVarData.planData) === null || _reactiveVarData$plan28 === void 0 ? void 0 : (_reactiveVarData$plan29 = _reactiveVarData$plan28.plans) === null || _reactiveVarData$plan29 === void 0 ? void 0 : _reactiveVarData$plan29.find(function (p) {
            return (p === null || p === void 0 ? void 0 : p.name) === plan_name;
          }).premium),
          cdAccNumber: null,
          cheqDDTransReferenceNo: values === null || values === void 0 ? void 0 : values.onlinePayment.transactionId,
          cheqDDTransDate: null,
          chequeType: null,
          ifscCode: null,
          bankName: null,
          bankCode: null,
          bankLocation: null,
          branchName: null,
          gstNumber: null
        });
      } else if ((values === null || values === void 0 ? void 0 : values.paymentMethod) === getDomainData(PaymentTypeList, 'CD Wallet', 'value', 'code')) {
        var _reactiveVarData$plan30, _reactiveVarData$plan31, _reactiveVarData$plan32, _reactiveVarData$plan33;

        receiptArr.push({
          paymentMode: values === null || values === void 0 ? void 0 : values.paymentMethod,
          receiptAmount: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$plan30 = reactiveVarData.planData) === null || _reactiveVarData$plan30 === void 0 ? void 0 : (_reactiveVarData$plan31 = _reactiveVarData$plan30.plans) === null || _reactiveVarData$plan31 === void 0 ? void 0 : _reactiveVarData$plan31.find(function (p) {
            return (p === null || p === void 0 ? void 0 : p.name) === plan_name;
          }).premium.totalPremium) || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$plan32 = reactiveVarData.planData) === null || _reactiveVarData$plan32 === void 0 ? void 0 : (_reactiveVarData$plan33 = _reactiveVarData$plan32.plans) === null || _reactiveVarData$plan33 === void 0 ? void 0 : _reactiveVarData$plan33.find(function (p) {
            return (p === null || p === void 0 ? void 0 : p.name) === plan_name;
          }).premium),
          cdAccNumber: values === null || values === void 0 ? void 0 : values.cdWallet.cdAccountNo,
          cheqDDTransReferenceNo: null,
          cheqDDTransDate: null,
          chequeType: null,
          ifscCode: null,
          bankName: null,
          bankCode: null,
          bankLocation: null,
          branchName: null,
          gstNumber: null
        });
      } else {
        var _reactiveVarData$plan34, _reactiveVarData$plan35, _reactiveVarData$plan36, _reactiveVarData$plan37;

        receiptArr.push({
          paymentMode: values === null || values === void 0 ? void 0 : values.paymentMethod,
          receiptAmount: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$plan34 = reactiveVarData.planData) === null || _reactiveVarData$plan34 === void 0 ? void 0 : (_reactiveVarData$plan35 = _reactiveVarData$plan34.plans) === null || _reactiveVarData$plan35 === void 0 ? void 0 : _reactiveVarData$plan35.find(function (p) {
            return (p === null || p === void 0 ? void 0 : p.name) === plan_name;
          }).premium.totalPremium) || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$plan36 = reactiveVarData.planData) === null || _reactiveVarData$plan36 === void 0 ? void 0 : (_reactiveVarData$plan37 = _reactiveVarData$plan36.plans) === null || _reactiveVarData$plan37 === void 0 ? void 0 : _reactiveVarData$plan37.find(function (p) {
            return (p === null || p === void 0 ? void 0 : p.name) === plan_name;
          }).premium),
          cdAccNumber: null,
          cheqDDTransReferenceNo: null,
          cheqDDTransDate: null,
          chequeType: null,
          ifscCode: null,
          bankName: null,
          bankCode: null,
          bankLocation: null,
          branchName: null,
          gstNumber: null
        });
      }

      return receiptArr;
    };

    return {
      input: {
        businessType: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.quotationType,
        productCode: product_code,
        commonDetails: {
          proposalPaymentType: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalPaymentType,
          proposalNumber: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber,
          intermediary: {
            intermediaryCode: (_data$9 = data["".concat(reactiveVarName)]) !== null && _data$9 !== void 0 && (_data$9$intermediaryD = _data$9.intermediaryDetails) !== null && _data$9$intermediaryD !== void 0 && _data$9$intermediaryD.code ? "".concat((_data$10 = data["".concat(reactiveVarName)]) === null || _data$10 === void 0 ? void 0 : (_data$10$intermediary = _data$10.intermediaryDetails) === null || _data$10$intermediary === void 0 ? void 0 : _data$10$intermediary.code) : '',
            locationCode: (_data$11 = data["".concat(reactiveVarName)]) !== null && _data$11 !== void 0 && (_data$11$intermediary = _data$11.intermediaryDetails) !== null && _data$11$intermediary !== void 0 && _data$11$intermediary.location ? "".concat((_data$12 = data["".concat(reactiveVarName)]) === null || _data$12 === void 0 ? void 0 : (_data$12$intermediary = _data$12.intermediaryDetails) === null || _data$12$intermediary === void 0 ? void 0 : _data$12$intermediary.location) : '',
            fieldUserCode: (_data$13 = data["".concat(reactiveVarName)]) !== null && _data$13 !== void 0 && (_data$13$intermediary = _data$13.intermediaryDetails) !== null && _data$13$intermediary !== void 0 && _data$13$intermediary.fieldUserCode ? "".concat((_data$14 = data["".concat(reactiveVarName)]) === null || _data$14 === void 0 ? void 0 : (_data$14$intermediary = _data$14.intermediaryDetails) === null || _data$14$intermediary === void 0 ? void 0 : _data$14$intermediary.fieldUserCode) : ''
          },
          customerID: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop21 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop21 === void 0 ? void 0 : _reactiveVarData$prop21.id,
          totalPremium: parseFloat((reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$plan38 = reactiveVarData.planData) === null || _reactiveVarData$plan38 === void 0 ? void 0 : (_reactiveVarData$plan39 = _reactiveVarData$plan38.plans) === null || _reactiveVarData$plan39 === void 0 ? void 0 : (_reactiveVarData$plan40 = _reactiveVarData$plan39.find(function (p) {
            return (p === null || p === void 0 ? void 0 : p.name) === plan_name;
          })) === null || _reactiveVarData$plan40 === void 0 ? void 0 : (_reactiveVarData$plan41 = _reactiveVarData$plan40.premium) === null || _reactiveVarData$plan41 === void 0 ? void 0 : _reactiveVarData$plan41.totalPremium) || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$plan42 = reactiveVarData.planData) === null || _reactiveVarData$plan42 === void 0 ? void 0 : (_reactiveVarData$plan43 = _reactiveVarData$plan42.plans) === null || _reactiveVarData$plan43 === void 0 ? void 0 : (_reactiveVarData$plan44 = _reactiveVarData$plan43.find(function (p) {
            return (p === null || p === void 0 ? void 0 : p.name) === plan_name;
          })) === null || _reactiveVarData$plan44 === void 0 ? void 0 : _reactiveVarData$plan44.premium)),
          payerType: values === null || values === void 0 ? void 0 : values.payerType,
          policy_Num: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.businessType) === 'Renewal Business' ? reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.policyNumber : '' //SAEA BT20641

        },
        receiptDetails: getReceiptDetails(),
        modeOfOperation: modeOfOperation ? modeOfOperation : (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.businessType) === 'Renewal Business' ? 'RENEWPOLICY' : undefined
      }
    };
  };

  var getKashPayVariables = function getKashPayVariables(values, refillCDAccDtls) {
    var _data$15, _data$15$intermediary, _data$16, _data$16$intermediary, _data$17, _data$17$intermediary, _data$18, _data$18$intermediary, _reactiveVarData$prop22, _reactiveVarData$prop23, _reactiveVarData$prop24, _reactiveVarData$prop25, _reactiveVarData$prop26, _reactiveVarData$prop27, _reactiveVarData$prop28, _reactiveVarData$prop29, _reactiveVarData$prop30, _reactiveVarData$prop31, _reactiveVarData$inte3, _reactiveVarData$plan57, _reactiveVarData$plan58, _reactiveVarData$plan59, _reactiveVarData$plan60, _reactiveVarData$plan61, _reactiveVarData$plan62, _reactiveVarData$plan63, _reactiveVarData$plan64, _reactiveVarData$plan65, _reactiveVarData$prop32, _reactiveVarData$poli, _values$cdWallet2;

    var getReceiptDetails = function getReceiptDetails() {
      var receiptArr = [];

      if ((values === null || values === void 0 ? void 0 : values.paymentMethod) === getDomainData(PaymentTypeList, 'Cheque', 'value', 'code')) {
        values === null || values === void 0 ? void 0 : values.cheque.forEach(function (_, idx) {
          receiptArr.push({
            paymentMode: values === null || values === void 0 ? void 0 : values.paymentMethod,
            receiptAmount: parseFloat(values === null || values === void 0 ? void 0 : values.cheque[idx].paymentAmount),
            cdAccNumber: null,
            cheqDDTransReferenceNo: values === null || values === void 0 ? void 0 : values.cheque[idx].chequeNumber,
            cheqDDTransDate: values === null || values === void 0 ? void 0 : values.cheque[idx].chequeDate,
            // chequeType:values?.cheque[idx].chequeType ,//values?.cheque[idx].chequeType,
            //chequeType: values?.cheque[idx].bankName =='KOTAK' ? '0' :'1', match(/^[0-9]+$/,,match(/^[0-9]+$/))
            // chequeType: values?.cheque[idx].bankName.toLowerCase().search("kotak") ? '0' :'1', 
            chequeType: "",
            ifscCode: values === null || values === void 0 ? void 0 : values.cheque[idx].ifscCode,
            bankName: values === null || values === void 0 ? void 0 : values.cheque[idx].bankName,
            bankCode: values === null || values === void 0 ? void 0 : values.cheque[idx].bankCode,
            bankLocation: values === null || values === void 0 ? void 0 : values.cheque[idx].branchLocation,
            branchName: values === null || values === void 0 ? void 0 : values.cheque[idx].branchName,
            gstNumber: null
          });
        });
      } else if ((values === null || values === void 0 ? void 0 : values.paymentMethod) === getDomainData(PaymentTypeList, 'Demand Draft', 'value', 'code')) {
        values === null || values === void 0 ? void 0 : values.demandDraft.forEach(function (_, idx) {
          receiptArr.push({
            paymentMode: values === null || values === void 0 ? void 0 : values.paymentMethod,
            receiptAmount: parseFloat(values === null || values === void 0 ? void 0 : values.demandDraft[idx].paymentAmount),
            cdAccNumber: null,
            cheqDDTransReferenceNo: values === null || values === void 0 ? void 0 : values.demandDraft[idx].ddNumber,
            cheqDDTransDate: values === null || values === void 0 ? void 0 : values.demandDraft[idx].ddDate,
            chequeType: null,
            ifscCode: values === null || values === void 0 ? void 0 : values.demandDraft[idx].ifscCode,
            bankName: values === null || values === void 0 ? void 0 : values.demandDraft[idx].bankName,
            bankCode: values === null || values === void 0 ? void 0 : values.demandDraft[idx].bankCode,
            bankLocation: values === null || values === void 0 ? void 0 : values.demandDraft[idx].branchLocation,
            branchName: values === null || values === void 0 ? void 0 : values.demandDraft[idx].branchName,
            gstNumber: null
          });
        });
      } else if ((values === null || values === void 0 ? void 0 : values.paymentMethod) === getDomainData(PaymentTypeList, 'Offline Payment', 'value', 'code')) {
        var _reactiveVarData$plan45, _reactiveVarData$plan46, _reactiveVarData$plan47, _reactiveVarData$plan48;

        receiptArr.push({
          paymentMode: values === null || values === void 0 ? void 0 : values.paymentMethod,
          receiptAmount: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$plan45 = reactiveVarData.planData) === null || _reactiveVarData$plan45 === void 0 ? void 0 : (_reactiveVarData$plan46 = _reactiveVarData$plan45.plans) === null || _reactiveVarData$plan46 === void 0 ? void 0 : _reactiveVarData$plan46.find(function (p) {
            return (p === null || p === void 0 ? void 0 : p.name) === plan_name;
          }).premium.totalPremium) || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$plan47 = reactiveVarData.planData) === null || _reactiveVarData$plan47 === void 0 ? void 0 : (_reactiveVarData$plan48 = _reactiveVarData$plan47.plans) === null || _reactiveVarData$plan48 === void 0 ? void 0 : _reactiveVarData$plan48.find(function (p) {
            return (p === null || p === void 0 ? void 0 : p.name) === plan_name;
          }).premium),
          cdAccNumber: null,
          cheqDDTransReferenceNo: values === null || values === void 0 ? void 0 : values.onlinePayment.transactionId,
          cheqDDTransDate: null,
          chequeType: null,
          ifscCode: null,
          bankName: null,
          bankCode: null,
          bankLocation: null,
          branchName: null,
          gstNumber: null
        });
      } else if ((values === null || values === void 0 ? void 0 : values.paymentMethod) === getDomainData(PaymentTypeList, 'CD Wallet', 'value', 'code')) {
        var _reactiveVarData$plan49, _reactiveVarData$plan50, _reactiveVarData$plan51, _reactiveVarData$plan52;

        receiptArr.push({
          paymentMode: values === null || values === void 0 ? void 0 : values.paymentMethod,
          receiptAmount: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$plan49 = reactiveVarData.planData) === null || _reactiveVarData$plan49 === void 0 ? void 0 : (_reactiveVarData$plan50 = _reactiveVarData$plan49.plans) === null || _reactiveVarData$plan50 === void 0 ? void 0 : _reactiveVarData$plan50.find(function (p) {
            return (p === null || p === void 0 ? void 0 : p.name) === plan_name;
          }).premium.totalPremium) || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$plan51 = reactiveVarData.planData) === null || _reactiveVarData$plan51 === void 0 ? void 0 : (_reactiveVarData$plan52 = _reactiveVarData$plan51.plans) === null || _reactiveVarData$plan52 === void 0 ? void 0 : _reactiveVarData$plan52.find(function (p) {
            return (p === null || p === void 0 ? void 0 : p.name) === plan_name;
          }).premium),
          cdAccNumber: values === null || values === void 0 ? void 0 : values.cdWallet.cdAccountNo,
          cheqDDTransReferenceNo: null,
          cheqDDTransDate: null,
          chequeType: null,
          ifscCode: null,
          bankName: null,
          bankCode: null,
          bankLocation: null,
          branchName: null,
          gstNumber: null
        });
      } else {
        var _reactiveVarData$plan53, _reactiveVarData$plan54, _reactiveVarData$plan55, _reactiveVarData$plan56;

        receiptArr.push({
          paymentMode: values === null || values === void 0 ? void 0 : values.paymentMethod,
          receiptAmount: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$plan53 = reactiveVarData.planData) === null || _reactiveVarData$plan53 === void 0 ? void 0 : (_reactiveVarData$plan54 = _reactiveVarData$plan53.plans) === null || _reactiveVarData$plan54 === void 0 ? void 0 : _reactiveVarData$plan54.find(function (p) {
            return (p === null || p === void 0 ? void 0 : p.name) === plan_name;
          }).premium.totalPremium) || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$plan55 = reactiveVarData.planData) === null || _reactiveVarData$plan55 === void 0 ? void 0 : (_reactiveVarData$plan56 = _reactiveVarData$plan55.plans) === null || _reactiveVarData$plan56 === void 0 ? void 0 : _reactiveVarData$plan56.find(function (p) {
            return (p === null || p === void 0 ? void 0 : p.name) === plan_name;
          }).premium),
          cdAccNumber: null,
          cheqDDTransReferenceNo: null,
          cheqDDTransDate: null,
          chequeType: null,
          ifscCode: null,
          bankName: null,
          bankCode: null,
          bankLocation: null,
          branchName: null,
          gstNumber: null
        });
      }

      return receiptArr;
    };

    return {
      input: {
        imdCode: (_data$15 = data["".concat(reactiveVarName)]) !== null && _data$15 !== void 0 && (_data$15$intermediary = _data$15.intermediaryDetails) !== null && _data$15$intermediary !== void 0 && _data$15$intermediary.code ? "".concat((_data$16 = data["".concat(reactiveVarName)]) === null || _data$16 === void 0 ? void 0 : (_data$16$intermediary = _data$16.intermediaryDetails) === null || _data$16$intermediary === void 0 ? void 0 : _data$16$intermediary.code) : '',
        imdName: (_data$17 = data["".concat(reactiveVarName)]) !== null && _data$17 !== void 0 && (_data$17$intermediary = _data$17.intermediaryDetails) !== null && _data$17$intermediary !== void 0 && _data$17$intermediary.value ? "".concat((_data$18 = data["".concat(reactiveVarName)]) === null || _data$18 === void 0 ? void 0 : (_data$18$intermediary = _data$18.intermediaryDetails) === null || _data$18$intermediary === void 0 ? void 0 : _data$18$intermediary.value) : '',
        payerName: (values === null || values === void 0 ? void 0 : values.payerType) === getDomainData(PayMethodPayerTypeList, 'Customer', 'value', 'code') ? (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop22 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop22 === void 0 ? void 0 : _reactiveVarData$prop22.customerType) === getDomainData(customerTypeList, 'Individual', 'value', 'code') ? [getDomainData(salutationList, reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop23 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop23 === void 0 ? void 0 : (_reactiveVarData$prop24 = _reactiveVarData$prop23.title) === null || _reactiveVarData$prop24 === void 0 ? void 0 : _reactiveVarData$prop24.trim(), 'code', 'value'), reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop25 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop25 === void 0 ? void 0 : (_reactiveVarData$prop26 = _reactiveVarData$prop25.firstName) === null || _reactiveVarData$prop26 === void 0 ? void 0 : _reactiveVarData$prop26.trim(), reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop27 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop27 === void 0 ? void 0 : (_reactiveVarData$prop28 = _reactiveVarData$prop27.middleName) === null || _reactiveVarData$prop28 === void 0 ? void 0 : _reactiveVarData$prop28.trim(), reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop29 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop29 === void 0 ? void 0 : (_reactiveVarData$prop30 = _reactiveVarData$prop29.lastName) === null || _reactiveVarData$prop30 === void 0 ? void 0 : _reactiveVarData$prop30.trim()].filter(function (n) {
          return n;
        }).join(' ') : reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop31 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop31 === void 0 ? void 0 : _reactiveVarData$prop31.orgName : reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$inte3 = reactiveVarData.intermediaryDetails) === null || _reactiveVarData$inte3 === void 0 ? void 0 : _reactiveVarData$inte3.intermediaryName,
        receiptNumber: refillCDAccDtls === null || refillCDAccDtls === void 0 ? void 0 : refillCDAccDtls.receiptID,
        receiptAmount: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$plan57 = reactiveVarData.planData) === null || _reactiveVarData$plan57 === void 0 ? void 0 : (_reactiveVarData$plan58 = _reactiveVarData$plan57.plans) === null || _reactiveVarData$plan58 === void 0 ? void 0 : (_reactiveVarData$plan59 = _reactiveVarData$plan58.find(function (p) {
          return (p === null || p === void 0 ? void 0 : p.name) === plan_name;
        })) === null || _reactiveVarData$plan59 === void 0 ? void 0 : (_reactiveVarData$plan60 = _reactiveVarData$plan59.premium) === null || _reactiveVarData$plan60 === void 0 ? void 0 : (_reactiveVarData$plan61 = _reactiveVarData$plan60.totalPremium) === null || _reactiveVarData$plan61 === void 0 ? void 0 : _reactiveVarData$plan61.toString()) || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$plan62 = reactiveVarData.planData) === null || _reactiveVarData$plan62 === void 0 ? void 0 : (_reactiveVarData$plan63 = _reactiveVarData$plan62.plans) === null || _reactiveVarData$plan63 === void 0 ? void 0 : (_reactiveVarData$plan64 = _reactiveVarData$plan63.find(function (p) {
          return (p === null || p === void 0 ? void 0 : p.name) === plan_name;
        })) === null || _reactiveVarData$plan64 === void 0 ? void 0 : (_reactiveVarData$plan65 = _reactiveVarData$plan64.premium) === null || _reactiveVarData$plan65 === void 0 ? void 0 : _reactiveVarData$plan65.toString()),
        customerID: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop32 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop32 === void 0 ? void 0 : _reactiveVarData$prop32.id,
        proposalPaymentType: reactiveVarData.proposalPaymentType,
        proposalNumber: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber,
        proposalDate: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$poli = reactiveVarData.policy) === null || _reactiveVarData$poli === void 0 ? void 0 : _reactiveVarData$poli.startDate,
        policyNo: refillCDAccDtls === null || refillCDAccDtls === void 0 ? void 0 : refillCDAccDtls.policyNo,
        productName: productName,
        cdAccNo: values === null || values === void 0 ? void 0 : (_values$cdWallet2 = values.cdWallet) === null || _values$cdWallet2 === void 0 ? void 0 : _values$cdWallet2.cdAccountNo,
        payerType: values === null || values === void 0 ? void 0 : values.payerType,
        type: "proposal",
        paymentMode: values === null || values === void 0 ? void 0 : values.paymentMethod,
        receiptDetails: getReceiptDetails()
      }
    };
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values) {
      var _data$issuePolicy4, _data$issuePolicy5, _data$issuePolicy6, _data$issuePolicy7, _data$issuePolicy8, _data$issuePolicy9, _data$issuePolicy10, _data$issuePolicy11, _data$issuePolicy12, issuePolicy, _yield$issuePolicy, _data, _data$issuePolicy, _data$issuePolicy2, _data$issuePolicy3, kashPaySlipQuery;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(Object.keys(validate(values)).length === 0)) {
                _context.next = 32;
                break;
              }

              _context.prev = 1;
              issuePolicy = mutateQuery({
                mutation: ISSUE_POLICY,
                variables: renewPolicyVariables(values)
              });
              setCustomLoadingMessage('Processing');
              window.scrollTo({
                top: 0
              });
              setLD(1);
              disableScroll.on();
              _context.next = 9;
              return issuePolicy;

            case 9:
              _yield$issuePolicy = _context.sent;
              _data = _yield$issuePolicy.data;
              setLD('');
              disableScroll.off();
              /* kashPaySlipQuery - Inserting the Receipt Number in master table to generate payslip*/

              if (!((values === null || values === void 0 ? void 0 : values.paymentMethod) === 'C' || (values === null || values === void 0 ? void 0 : values.paymentMethod) === 'D')) {
                _context.next = 19;
                break;
              }

              kashPaySlipQuery = mutateQuery({
                mutation: KASH_PASH_SLIP,
                variables: getKashPayVariables(values, {
                  receiptID: _data !== null && _data !== void 0 && (_data$issuePolicy = _data.issuePolicy) !== null && _data$issuePolicy !== void 0 && _data$issuePolicy.receiptID ? _data === null || _data === void 0 ? void 0 : (_data$issuePolicy2 = _data.issuePolicy) === null || _data$issuePolicy2 === void 0 ? void 0 : _data$issuePolicy2.receiptID : [],
                  policyNo: reformData(_data === null || _data === void 0 ? void 0 : (_data$issuePolicy3 = _data.issuePolicy) === null || _data$issuePolicy3 === void 0 ? void 0 : _data$issuePolicy3.policyNo, '')
                })
              });
              _context.next = 17;
              return kashPaySlipQuery;

            case 17:

            case 19:
              updateReactiveVar({
                isPolicyIssued: true,
                issuedPolicyData: {
                  policyNo: reformData(_data === null || _data === void 0 ? void 0 : (_data$issuePolicy4 = _data.issuePolicy) === null || _data$issuePolicy4 === void 0 ? void 0 : _data$issuePolicy4.policyNo, ''),
                  receiptID: _data !== null && _data !== void 0 && (_data$issuePolicy5 = _data.issuePolicy) !== null && _data$issuePolicy5 !== void 0 && _data$issuePolicy5.receiptID ? _data === null || _data === void 0 ? void 0 : (_data$issuePolicy6 = _data.issuePolicy) === null || _data$issuePolicy6 === void 0 ? void 0 : _data$issuePolicy6.receiptID : [],
                  referenceNumber: reformData(_data === null || _data === void 0 ? void 0 : (_data$issuePolicy7 = _data.issuePolicy) === null || _data$issuePolicy7 === void 0 ? void 0 : _data$issuePolicy7.referenceNumber, ''),
                  digiLink: reformData(_data === null || _data === void 0 ? void 0 : (_data$issuePolicy8 = _data.issuePolicy) === null || _data$issuePolicy8 === void 0 ? void 0 : _data$issuePolicy8.digiLink, ''),
                  displayMessage: reformData(_data === null || _data === void 0 ? void 0 : (_data$issuePolicy9 = _data.issuePolicy) === null || _data$issuePolicy9 === void 0 ? void 0 : _data$issuePolicy9.displayMessage, ''),
                  additionalMessage: reformData(_data === null || _data === void 0 ? void 0 : (_data$issuePolicy10 = _data.issuePolicy) === null || _data$issuePolicy10 === void 0 ? void 0 : _data$issuePolicy10.additionalMessage, '')
                },
                premiumDetails: values
              });

              if (_data !== null && _data !== void 0 && (_data$issuePolicy11 = _data.issuePolicy) !== null && _data$issuePolicy11 !== void 0 && _data$issuePolicy11.policyNo && (_data === null || _data === void 0 ? void 0 : (_data$issuePolicy12 = _data.issuePolicy) === null || _data$issuePolicy12 === void 0 ? void 0 : _data$issuePolicy12.policyNo.length) > 0) {
                setLD('');
                disableScroll.off();
                setParentAlerts([{
                  header: 'Policy issue success',
                  id: Date.now(),
                  content: /*#__PURE__*/React.createElement("div", {
                    className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                  }, /*#__PURE__*/React.createElement("span", null, 'Policy issued successfully')),
                  type: 'success',
                  timeout: null,
                  disableClose: false
                }]);
              }

              showSuccessMsg(true);
              return _context.abrupt("return", true);

            case 25:
              _context.prev = 25;
              _context.t0 = _context["catch"](1);
              setCustomLoadingMessage(null);
              setLD('');
              disableScroll.off();
              setParentAlerts([{
                header: 'Error',
                id: Date.now(),
                content: /*#__PURE__*/React.createElement("div", {
                  className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                }, /*#__PURE__*/React.createElement("span", null, _context.t0.message)),
                type: 'error',
                timeout: null,
                disableClose: false
              }]);
              return _context.abrupt("return", false);

            case 32:
              return _context.abrupt("return", false);

            case 33:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 25]]);
    }));

    return function onSubmit(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var initialValues = {
    termsAndConditions: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem = reactiveVarData.premiumDetails) === null || _reactiveVarData$prem === void 0 ? void 0 : _reactiveVarData$prem.termsAndConditions,
    paymentMethod: reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.premiumDetails.paymentMethod ? reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.premiumDetails.paymentMethod : getDomainData(PaymentTypeList, (_PaymentTypeList$ = PaymentTypeList[0]) === null || _PaymentTypeList$ === void 0 ? void 0 : _PaymentTypeList$.value, 'value', 'code'),
    payerType: reactiveVarData !== null && reactiveVarData !== void 0 && (_reactiveVarData$prem2 = reactiveVarData.premiumDetails) !== null && _reactiveVarData$prem2 !== void 0 && _reactiveVarData$prem2.payerType ? reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem3 = reactiveVarData.premiumDetails) === null || _reactiveVarData$prem3 === void 0 ? void 0 : _reactiveVarData$prem3.payerType : PayMethodPayerTypeList ? getDomainData(PayMethodPayerTypeList, 'Customer', 'value', 'code') : '',
    onlinePayment: {
      transactionId: reactiveVarData !== null && reactiveVarData !== void 0 && (_reactiveVarData$prem4 = reactiveVarData.premiumDetails) !== null && _reactiveVarData$prem4 !== void 0 && (_reactiveVarData$prem5 = _reactiveVarData$prem4.onlinePayment) !== null && _reactiveVarData$prem5 !== void 0 && _reactiveVarData$prem5.transactionId ? reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem6 = reactiveVarData.premiumDetails) === null || _reactiveVarData$prem6 === void 0 ? void 0 : (_reactiveVarData$prem7 = _reactiveVarData$prem6.onlinePayment) === null || _reactiveVarData$prem7 === void 0 ? void 0 : _reactiveVarData$prem7.transactionId : '',
      isTransactionIdVerified: reactiveVarData !== null && reactiveVarData !== void 0 && (_reactiveVarData$prem8 = reactiveVarData.premiumDetails) !== null && _reactiveVarData$prem8 !== void 0 && (_reactiveVarData$prem9 = _reactiveVarData$prem8.onlinePayment) !== null && _reactiveVarData$prem9 !== void 0 && _reactiveVarData$prem9.isTransactionIdVerified ? reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem10 = reactiveVarData.premiumDetails) === null || _reactiveVarData$prem10 === void 0 ? void 0 : (_reactiveVarData$prem11 = _reactiveVarData$prem10.onlinePayment) === null || _reactiveVarData$prem11 === void 0 ? void 0 : _reactiveVarData$prem11.isTransactionIdVerified : false
    },
    cdWallet: {
      cdAccountNo: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem12 = reactiveVarData.premiumDetails) === null || _reactiveVarData$prem12 === void 0 ? void 0 : (_reactiveVarData$prem13 = _reactiveVarData$prem12.cdWallet) === null || _reactiveVarData$prem13 === void 0 ? void 0 : _reactiveVarData$prem13.cdAccountNo,
      cdAccountBalance: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem14 = reactiveVarData.premiumDetails) === null || _reactiveVarData$prem14 === void 0 ? void 0 : (_reactiveVarData$prem15 = _reactiveVarData$prem14.cdWallet) === null || _reactiveVarData$prem15 === void 0 ? void 0 : _reactiveVarData$prem15.cdAccountBalance,
      cdAccountCount: 0
    },
    cheque: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem16 = reactiveVarData.premiumDetails) === null || _reactiveVarData$prem16 === void 0 ? void 0 : (_reactiveVarData$prem17 = _reactiveVarData$prem16.cheque) === null || _reactiveVarData$prem17 === void 0 ? void 0 : _reactiveVarData$prem17.length) === 0 ? [{
      ifscCode: '',
      bankName: '',
      bankCode: '',
      chequeType: '',
      chequeNumber: '',
      chequeDate: dateTimeData === null || dateTimeData === void 0 ? void 0 : (_dateTimeData$datetim3 = dateTimeData.datetimeValue) === null || _dateTimeData$datetim3 === void 0 ? void 0 : _dateTimeData$datetim3.date,
      paymentAmount: '',
      branchName: '',
      branchLocation: ''
    }] : reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem18 = reactiveVarData.premiumDetails) === null || _reactiveVarData$prem18 === void 0 ? void 0 : (_reactiveVarData$prem19 = _reactiveVarData$prem18.cheque) === null || _reactiveVarData$prem19 === void 0 ? void 0 : _reactiveVarData$prem19.map(function (cheque) {
      var _dateTimeData$datetim4;

      return _objectSpread2(_objectSpread2({}, cheque), {}, {
        chequeDate: dateTimeData === null || dateTimeData === void 0 ? void 0 : (_dateTimeData$datetim4 = dateTimeData.datetimeValue) === null || _dateTimeData$datetim4 === void 0 ? void 0 : _dateTimeData$datetim4.date
      });
    }),
    demandDraft: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem20 = reactiveVarData.premiumDetails) === null || _reactiveVarData$prem20 === void 0 ? void 0 : (_reactiveVarData$prem21 = _reactiveVarData$prem20.demandDraft) === null || _reactiveVarData$prem21 === void 0 ? void 0 : _reactiveVarData$prem21.length) === 0 ? [{
      ifscCode: '',
      bankName: '',
      bankCode: '',
      ddNumber: '',
      ddDate: dateTimeData === null || dateTimeData === void 0 ? void 0 : (_dateTimeData$datetim5 = dateTimeData.datetimeValue) === null || _dateTimeData$datetim5 === void 0 ? void 0 : _dateTimeData$datetim5.date,
      paymentAmount: '',
      branchName: '',
      branchLocation: ''
    }] : reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem22 = reactiveVarData.premiumDetails) === null || _reactiveVarData$prem22 === void 0 ? void 0 : (_reactiveVarData$prem23 = _reactiveVarData$prem22.demandDraft) === null || _reactiveVarData$prem23 === void 0 ? void 0 : _reactiveVarData$prem23.map(function (demandDraft) {
      var _dateTimeData$datetim6;

      return _objectSpread2(_objectSpread2({}, demandDraft), {}, {
        ddDate: dateTimeData === null || dateTimeData === void 0 ? void 0 : (_dateTimeData$datetim6 = dateTimeData.datetimeValue) === null || _dateTimeData$datetim6 === void 0 ? void 0 : _dateTimeData$datetim6.date
      });
    })
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(QuantaFormik, {
    innerRef: props.forwardedRef,
    initialValues: initialValues,
    enableReinitialize: true,
    validate: validate,
    onSubmit: onSubmit,
    validator: function validator() {
      return {};
    }
  }, /*#__PURE__*/React.createElement(RenewPayPremiumForm, {
    validate: validate
  })), /*#__PURE__*/React.createElement(TermsAndConditions, {
    setShow: setShow,
    showterms: showterms
  }));
}

export { CdWalletHealth as C, PayPremium as P };
